export default __webpack_public_path__ + "static/media/heathens.642c39fd.mp3";